import { TileLayer, BitmapLayer, IconLayer, GeoJsonLayer } from "deck.gl";

export class OSMLayer extends TileLayer {
  constructor() {
    super({
      id : 'osm-layer',

      data: [
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ],

      tileSize: 256,

      renderSubLayers: (props) => {
        const {
          bbox: { west, south, east, north }
        } = props.tile;

        return new BitmapLayer(props, {
          data: null,
          image: props.data,
          bounds: [west, south, east, north],
        });
      }
    });
  };
}

export function renderStationLayer(data, clickedStation, lineCd, zoom) {
  const icon_mapping = {
    marker: { x: 0, y: 0, width: 128, height: 128, anchorY:128, mask: true },
  };

  const stationLayer = new IconLayer({
    id: 'station-layer',
    data: data,
    pickable: true,
    iconAtlas: 'https://raw.githubusercontent.com/visgl/deck.gl-data/master/website/icon-atlas.png',
    iconMapping: icon_mapping,
    getIcon: () => 'marker',

    sizeUnits: 'pixels',
    sizeScale: 1,
    getSize: () => {
      if (lineCd === "all" && zoom < 5) {
        return 7;
      } else if (lineCd === "all" && zoom < 6.5) {
        return 14;
      } else if (lineCd === "all" && zoom < 8.5) {
        return 21;
      } else if (zoom < 10) {
        return 30;
      } else {
        return 40;
      }
    },

    getPosition: (d) => d.location,
    getColor: (d) => (clickedStation && d.station_g_cd === clickedStation.station_g_cd)? [255, 0, 255] : [0, 0, 255],

    alphaCutoff: 0,

    updateTriggers: {
      getColor: [clickedStation?.station_g_cd, data],
      getSize: [lineCd, zoom],
    }
  });

  return stationLayer;
}

export function renderRouteLayer(data) {
  const routeLayer = new GeoJsonLayer({
    id: 'route-layer',
    data: data,
    getLineColor: [255, 0, 0],
    getLineWidth: 4,
    lineWidthUnits: 'pixels',
  });

  return routeLayer;
}

export function renderAllLayers(props) {
  const osmLayer = new OSMLayer();
  const routeLayer = props.routeData? renderRouteLayer(props.routeData) : null;
  const stationLayer = props.stationData? renderStationLayer(props.stationData, props.clickedStation, props.lineCd, props.zoom) : null;

  return [
    osmLayer,
    routeLayer,
    stationLayer,
  ];
}
